<template>
  <div>
    <div class="content" v-if="!needLoading">
      <div class="content_sub_title">
        <p>{{curThreat.subject}}</p>
        <p v-if="curThreat.subjectDesc && curThreat.subjectDesc.length>0">{{curThreat.subjectDesc}}</p>
        <p>{{curThreat.city}}</p>
      </div>
      <p class="content_normal">{{curThreat.dear}}</p>
      <p :class="threatType === 'flypay' ? 'content_title_flypay' : 'content_title'">{{curThreat.title}}</p>
      <p v-if="curThreat.subTitle && curThreat.subTitle.length > 0">{{curThreat.subTitle}}</p>
      <swift-m2 v-if="month==='2' && threatType==='swift'"/>
      <swift-m3 v-if="month==='3' && threatType==='swift'" />
      <swift-m5 v-if="month==='5' && threatType==='swift'" />
      <m2 v-if="month==='2' && threatType==='lcredit'" />
      <m3 v-if="month==='3' && threatType==='lcredit'" />
      <m4 v-if="month==='4' && threatType==='lcredit'" />
      <m5 v-if="month==='5' && threatType==='lcredit'" />
      <flypay-m1 v-if="month==='1' && threatType==='flypay'" />
      <flypay-m2 v-if="month==='2' && threatType==='flypay'" />
      <flypay-m3 v-if="month==='3' && threatType==='flypay'" />
      <flypay-m4 v-if="month==='4' && threatType==='flypay'" />
      <flypay-m5 v-if="month==='5' && threatType==='flypay'" />
    </div>
    <loading v-if="needLoading" />
  </div>
</template>

<script>
import loading from '../components/Loading/loading.vue';
import SwiftM2 from './components/swift_M2.vue';
import SwiftM3 from './components/swift_M3.vue';
import SwiftM5 from './components/swift_M5.vue';
import M2 from './components/M2.vue';
import M3 from './components/M3.vue';
import M4 from './components/M4.vue';
import M5 from './components/M5.vue';
import FlypayM1 from './components/flypay_M1.vue';
import FlypayM2 from './components/flypay_M2.vue';
import FlypayM3 from './components/flypay_M3.vue';
import FlypayM4 from './components/flypay_M4.vue';
import FlypayM5 from './components/flypay_M5.vue';

export default {
  name: 'index',
  components: {
    FlypayM1,
    FlypayM2,
    FlypayM3,
    FlypayM4,
    FlypayM5,
    M5,
    M4,
    M3,
    M2,
    SwiftM5,
    SwiftM3,
    SwiftM2,
    loading,
  },
  data() {
    return {
      month: '2',
      threatType: 'lcredit',
      needLoading: true,
      threat: {
        swift: {
          subject: 'ULTIMCRED Limited (Swiftkash)',
          city: 'Lagos Nigeria..',
          dear: 'Dear Sir/Madam',
          title: 'TORT OF NEGLIGENCE (BREACH OF CONTRACT)',
          subTitle: 'The Subject Matter refers.',
        },
        lcredit: {
          subject: 'Cashigo International Limited (LCredit)',
          city: 'Lagos Nigeria..',
          dear: 'Dear Sir/Madam',
          title: 'TORT OF NEGLIGENCE (BREACH OF CONTRACT)',
          subTitle: 'The Subject Matter refers.',
        },
        flypay: {
          subject: 'Flypay',
          subjectDesc: 'Victoria Island,',
          city: 'Lagos, Nigeria',
          dear: 'Dear Sir/Ma,',
          title: 'NOTIFICATION OF BREACH IN CONTRACT',
          subTitle: '',
        },
      },
      curThreat: {},
    };
  },
  mounted() {
    const ua = window.navigator.userAgent;
    const urlArr = window.location.hash.split('/');
    this.month = urlArr[urlArr.length - 1].slice(1);
    if (/Mobile/i.test(ua)) {
      this.needLoading = true;
      window.location.href = `${window.location.origin}#/CSMobile/M${this.month}`;
      return;
    }
    const { host } = window.location;
    if (host.includes('swiftkash')) {
      this.curThreat = this.threat.swift;
      this.threatType = 'swift';
    } else if (host.includes('flypay')) {
      this.curThreat = this.threat.flypay;
      this.threatType = 'flypay';
      if (this.month !== '1') {
        const indexs = ['', 'I', 'II', 'III', 'IV'];
        this.curThreat.title = `${this.curThreat.title}(PRE-LITIGATION STAGE ${indexs[this.month - 1]})`;
      }
    } else {
      this.curThreat = this.threat.lcredit;
      this.threatType = 'lcredit';
    }


    this.needLoading = false;
  },
};
</script>

<style lang="stylus" scoped>
  px = (1 / 24.75vw);
  .content {
    padding: 25 *px 16 *px;
    .content_title {
      font-size: 21px;
      margin: 10*px 0;
      font-weight:700;
    }
    .content_title_flypay {
      font-size: 21px;
      margin: 10*px 0;
      font-weight: normal;
      text-align:center;
    }
    .content_sub_title {
      text-align: right;
    }
    .content_normal {
      text-align: left;
    }
    p {
      margin: 10*px 0;
    }
  }
</style>
